import {Directive, ElementRef, Input, OnDestroy, OnInit} from '@angular/core';

@Directive({
    selector: '[appCounterUp]'
})
export class CounterUpDirective implements OnInit, OnDestroy {
    @Input() appCounterUp: number = 0;
    private observer!: IntersectionObserver; // Use the non-null assertion operator

    constructor(private el: ElementRef) {
    }

    ngOnInit() {
        this.observer = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting) {
                this.counterUp();
            }
        }, {threshold: 0.5}); // Trigger when 50% of the element is in view

        this.observer.observe(this.el.nativeElement);
    }

    ngOnDestroy() {
        if (this.observer) {
            this.observer.disconnect();
        }
    }

    counterUp() {
        let element = this.el.nativeElement;
        let countTo = this.appCounterUp;
        let currentValue = 0;

        const steps = 100;
        const increment = countTo / steps;

        const interval = setInterval(() => {
            currentValue += increment;
            element.innerText = Math.floor(currentValue);

            if (currentValue >= countTo) {
                clearInterval(interval);
                element.innerText = countTo;
            }
        }, 10);
    }
}
